module.exports = "<forbidden></forbidden>\n"